export const translations = {
  fr: {
    nav: {
      about: "à propos",
      resume: "Mon CV",
      certificates: "Mes Certificats",
      portfolio: "Mon Portfolio",
    },
    a11y: {
      openMenu: "Ouvrir le menu",
      switchLanguage: "Switch to English",
      closeModal: "Fermer la fenêtre",
      viewProject: "Voir le projet",
      viewProjectDetails: "Voir les détails du projet",
    },
    about: {
      title: "à propos",
      // Texte repris du CV (résumé d'en-tête), découpé en paragraphes.
      bio: [
        "Développeur Full-Stack Python & Data, spécialisé dans la conception, le développement et le déploiement de solutions métiers sur mesure. J'accompagne des cabinets de conseil, des incubateurs et des organisations dans la création d'applications robustes, de la modélisation des besoins jusqu'à la mise en production.",
        "En parallèle, j'interviens comme formateur en SQL, Power BI et Data Analytics, avec plus de 100 professionnels formés, dont des cadres et des DSI, notamment au sein du Groupe Axian et d'ACEP Madagascar.",
        "Cette double expertise, alliant ingénierie logicielle et transmission des connaissances, me permet de concevoir des solutions performantes, maintenables et centrées sur les besoins des utilisateurs.",
      ],
      cvBtn: "Mon CV",
      portfolioBtn: "Mon Portfolio",
    },
    personalInfo: {
      bio: "Développeur Full-Stack Python & Data · Formateur",
      phone: "Téléphone",
      email: "Email",
      address: "Adresse",
      downloadCV: "Télécharger mon CV",
    },
    cv: {
      title: "mon cv",
      education: "Parcours académique",
      experience: "expériences",
      devExperience: "Expériences en développement",
      teachingExperience: "Formations dispensées & enseignement",
      clients: "Clients",
      certifications: "Licences et Certifications",
      leadership: "Expériences associatives & leadership",
    },
    skills: {
      title: "Mes Compétences",
      categories: {
        frontend: "Frontend",
        backend: "Backend",
        framework: "Framework",
        database: "Base de données",
        data: "Data & ML",
        others: "Autres",
      },
    },
    portfolio: {
      title: "Mon Portfolio",
      technologies: "Technologies",
      description: "Description",
      github: "Voir sur GitHub",
      website: "Visiter le site",
      privateCode: "Code privé (propriété du client) — démonstration sur demande",
    },
    certificat: {
      view: "Consulter",
      empty: "Aucun certificat dans cette catégorie.",
      finalLabel: "Certificat final du parcours",
      showPath: "Voir les certificats du parcours",
      hidePath: "Masquer les certificats du parcours",
      filters: {
        all: "Toutes",
        Sololearn: "Sololearn",
        CodeSignal: "CodeSignal",
        autres: "Autres",
      },
    },
  },
  en: {
    nav: {
      about: "about",
      resume: "My Resume",
      certificates: "My Certificates",
      portfolio: "My Portfolio",
    },
    a11y: {
      openMenu: "Open the menu",
      switchLanguage: "Passer en Français",
      closeModal: "Close the dialog",
      viewProject: "View project",
      viewProjectDetails: "View project details",
    },
    about: {
      title: "about",
      // Traduction du résumé d'en-tête du CV.
      bio: [
        "Full-Stack Python & Data developer, specialised in designing, building and deploying tailor-made business software. I work with consulting firms, incubators and organisations to build robust applications, from requirements modelling through to production deployment.",
        "Alongside this, I work as a trainer in SQL, Power BI and Data Analytics, having trained over 100 professionals — including managers and CIOs — notably within Groupe Axian and ACEP Madagascar.",
        "This dual practice, combining software engineering with knowledge transfer, lets me design solutions that are performant, maintainable and centred on their users' needs.",
      ],
      cvBtn: "My Resume",
      portfolioBtn: "My Portfolio",
    },
    personalInfo: {
      bio: "Full-Stack Python & Data Developer · Trainer",
      phone: "Phone",
      email: "Email",
      address: "Address",
      downloadCV: "Download my CV",
    },
    cv: {
      title: "my resume",
      education: "Academic background",
      experience: "experiences",
      devExperience: "Development experience",
      teachingExperience: "Training & teaching",
      clients: "Clients",
      certifications: "Licenses & Certifications",
      leadership: "Community & Leadership Experience",
    },
    skills: {
      title: "My Skills",
      categories: {
        frontend: "Frontend",
        backend: "Backend",
        framework: "Framework",
        database: "Database",
        data: "Data & ML",
        others: "Others",
      },
    },
    portfolio: {
      title: "My Portfolio",
      technologies: "Technologies",
      description: "Description",
      github: "View on GitHub",
      website: "Visit Website",
      privateCode: "Private code (client-owned) — demo on request",
    },
    certificat: {
      view: "View",
      empty: "No certificates in this category.",
      finalLabel: "Final path certificate",
      showPath: "Show path certificates",
      hidePath: "Hide path certificates",
      filters: {
        all: "All",
        Sololearn: "Sololearn",
        CodeSignal: "CodeSignal",
        autres: "Others",
      },
    },
  },
};
